import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Observable } from 'rxjs';
import { PagedData } from '../models/paging/paged-data';
import { Page } from '../models/paging/page';
import { ServerData } from '../models/paging/server-data';

import { SnotifyService } from 'ng-snotify';
import { environment } from '../../environments/environment';
import { Region } from '../models/region';

@Injectable()
export class RegionService {
  constructor(private http: HttpClient, private snotifyService: SnotifyService) { }
  
  public getAll(company_Id: number): Promise<Region[]> {
    console.log(environment.apiUrl + 'region/getall?company_Id=' + company_Id)
    const headers = {
      'Content-Type': 'application/json',
    };
    return new Promise((resolve, reject) => {
      this.http.get<Region[]>(environment.apiUrl + 'region/getall?company_Id=' + company_Id, { headers: headers }).subscribe(data => {
        resolve(data);
      }, error => {
        console.log(error);
        reject();
      });
    });
  }

}
